"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enum_1 = require("./const/enum");
const qtyValid = (str) => {
    if (str === undefined || str === null) {
        return false;
    }
    if (str === '') {
        return true;
    }
    const num = Number(str);
    if (isNaN(num)) {
        return false;
    }
    return Number.isFinite(num);
};
class QuoteParser {
    constructor(helper, quoteRaw) {
        this.helper = helper;
        this.quoteRaw = quoteRaw;
        const parts = helper.symbol().split('/');
        this._baseCcy = parts[0];
        this._termsCcy = parts[1];
    }
    hasQuote() {
        return this.quoteRaw !== undefined;
    }
    client_x() {
        if (this.quoteRaw !== undefined && this.quoteRaw.client_ask !== undefined) {
            return this.quoteRaw.client_ask;
        }
        if (this.quoteRaw !== undefined && this.quoteRaw.client_bid !== undefined) {
            return this.quoteRaw.client_bid;
        }
    }
    price() {
        const client_x = this.client_x();
        if (client_x !== undefined) {
            return client_x.value;
        }
    }
    /**
     * The rate for `sellQty * rate = buyQty`
     * @returns {string|undefined} Rate
     */
    sellRate() {
        const price = this.price();
        if (price === undefined) {
            return undefined;
        }
        if (this.sellIsBase()) {
            return price;
        }
        return (1 / parseFloat(price)).toString();
    }
    /**
     * The rate for `buyQty * rate = sellQty`
     * @returns {string|undefined} Rate
     */
    buyRate() {
        const price = this.price();
        if (price === undefined) {
            return undefined;
        }
        if (this.buyIsBase()) {
            return price;
        }
        return (1 / parseFloat(price)).toString();
    }
    state() {
        if (this.quoteRaw === undefined) {
            return enum_1.QUOTE_STATE.PENDING;
        }
        const client_x = this.client_x();
        if (client_x !== undefined) {
            return client_x.state;
        }
        return enum_1.QUOTE_STATE.ERROR;
    }
    dealable() {
        return this.state() === enum_1.QUOTE_STATE.DEALABLE;
    }
    error() {
        return this.state() === enum_1.QUOTE_STATE.ERROR;
    }
    quantityAccepted() {
        return this.quoteRaw === undefined || this.quoteRaw.quantity_accepted !== false;
    }
    dealableQuantity() {
        return this.quoteRaw !== undefined ? this.quoteRaw.dealable_quantity : this.helper.quantity();
    }
    quotedQuantity() {
        return this.quoteRaw !== undefined ? this.quoteRaw.quoted_quantity : '';
    }
    quantityTooSmall() {
        const requestedQuantity = this.helper.quantity();
        const dealableQuantity = this.dealableQuantity();
        if (requestedQuantity === undefined || dealableQuantity === undefined) {
            return false;
        }
        return Number(dealableQuantity) > Number(requestedQuantity);
    }
    quantityTooLarge() {
        const requestedQuantity = this.helper.quantity();
        const dealableQuantity = this.dealableQuantity();
        if (requestedQuantity === undefined || dealableQuantity === undefined) {
            return false;
        }
        return Number(dealableQuantity) < Number(requestedQuantity);
    }
    sellQuantityValid() {
        return qtyValid(this.sellQuantity());
    }
    buyQuantityValid() {
        return qtyValid(this.buyQuantity());
    }
    sellCcy() {
        return this.helper.sellCcy();
    }
    buyCcy() {
        return this.helper.buyCcy();
    }
    baseCcy() {
        return this._baseCcy;
    }
    termsCcy() {
        return this._termsCcy;
    }
    sellIsBase() {
        return this.sellCcy() === this.baseCcy();
    }
    buyIsBase() {
        return this.buyCcy() === this.baseCcy();
    }
    fee() {
        if (this.quoteRaw !== undefined && this.quoteRaw.fee !== undefined) {
            return this.quoteRaw.fee;
        }
        return null;
    }
    quantityValid(side) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.buyQuantityValid();
            case enum_1.SIDE.SELL:
                return this.sellQuantityValid();
        }
    }
    sellQuantity() {
        if (this.quoteRaw === undefined) {
            return this.helper.sellQty();
        }
        // could also have used this.helper.sellCcyFixed()
        return this.helper.sellCcy() === this.quoteRaw.currency ? this.quoteRaw.dealable_quantity : this.quoteRaw.quoted_quantity;
    }
    buyQuantity() {
        if (this.quoteRaw === undefined) {
            return this.helper.buyQty();
        }
        // could also have used this.helper.buyCcyFixed()
        return this.helper.buyCcy() === this.quoteRaw.currency ? this.quoteRaw.dealable_quantity : this.quoteRaw.quoted_quantity;
    }
    qty(side) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.buyQuantity();
            case enum_1.SIDE.SELL:
                return this.sellQuantity();
        }
    }
    quantity() {
        return this.quoteRaw !== undefined ? this.quoteRaw.dealable_quantity : this.helper.quantity();
    }
    quantity_2() {
        return this.quoteRaw !== undefined ? this.quoteRaw.quoted_quantity : undefined;
    }
    symbol() {
        return this.quoteRaw !== undefined ? this.quoteRaw.symbol : this.helper.symbol();
    }
    currency() {
        return this.quoteRaw !== undefined ? this.quoteRaw.currency : this.helper.currency();
    }
    quoteId() {
        return this.quoteRaw !== undefined ? this.quoteRaw.quote_id : undefined;
    }
    side() {
        return this.helper.side();
    }
}
exports.QuoteParser = QuoteParser;
